class AppearanceConfig extends BasicAppearanceConfig {

    header: HeaderAppearanceConfig;
    border: BorderAppearanceConfig;

    constructor(data: any, dashboard: Dashboard) {
        super(data, dashboard);
        this.header = new HeaderAppearanceConfig(data.header, dashboard);
        this.border = new BorderAppearanceConfig(data.border, dashboard);
    }
}